export function Config() {
  this.apiUrl = "https://5340xvlkaa.execute-api.eu-west-1.amazonaws.com/";
}

